import Button from "../../../../components/ui/Button";
import Card, { CardBody } from "../../../../components/ui/Card";
import Modal, { ModalBody, ModalFooter, ModalFooterChild, ModalHeader } from "../../../../components/ui/Modal";
import { useState } from "react";
import { toast } from "react-toastify";
import { setAsMainPicture } from "../../../../services/vizyBilityServices";
import { useMsal } from "@azure/msal-react";

const SetAsMainModelConformationPopUp = ({ modalStatus, setModalStatus, AssetId, pictureId, refresh }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { instance, accounts } = useMsal();

  const handleSetMain = () => {
    setIsLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = `contextId=${AssetId}&contextTypeName=Asset&pictureId=${pictureId}`;
    setAsMainPicture(payload, header, instance, accounts)
      .then((res) => {
        toast.success("This image has been set as the main successfully.");
        setIsLoading(false);
        refresh();
        setModalStatus(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Something went wrong.");
      });
  };
  return (
    <>
      <Modal
        isOpen={modalStatus}
        setIsOpen={setModalStatus}
        isAnimation={true}
        isCentered={true}
        isScrollable={true}
        isStaticBackdrop={"rounded-3xl"}
        size={"sm"}
      >
        <ModalHeader>Set main picture</ModalHeader>
        <ModalBody>
          {isLoading ? (
            <div className="fixed w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50 top-0  right-0">
              <span class="loader"></span>
            </div>
          ) : null}
          <div className="text-[18px] mb-[10px]">You are about to set main picture.</div>
          <div className="text-[18px] ">Press OK to continue.</div>
        </ModalBody>

        <ModalFooter className="mt-[20px]">
          <ModalFooterChild></ModalFooterChild>
          <ModalFooterChild>
            <Button
              className="cursor-pointer flex items-center !text-white text-[16px] !bg-[#cb3b41]"
              onClick={() => setModalStatus(false)}
            >
              Close
            </Button>
            <Button
              className="cursor-pointer flex items-center !text-black text-[16px] !bg-[#FEBA06]"
              onClick={() => handleSetMain()}
            >
              OK
            </Button>
          </ModalFooterChild>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default SetAsMainModelConformationPopUp;
